export default __webpack_public_path__ + "static/media/banner3_costa_rica.0da3143b.png";